import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios, { removeBracketedText } from '../Axiosinstance';
import {
    TextField,
    Button,
    Grid,
    Typography,
    Paper,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,

} from '@mui/material'
import TablePagination from '@mui/material/TablePagination';
import Header from '../components/Header';

import * as XLSX from 'xlsx';
import { toast, ToastContainer } from 'react-toastify';
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from '../common'
import Loader from '../Loader';
import Modal from 'react-bootstrap/Modal';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import courserecipt from '../pdf/courserecipt.pdf'
import ExcelJS from 'exceljs';

const columns = [
    { id: 'name', label: 'Name' },
    { id: 'image', label: 'Nric' },
    { id: 'email', label: 'Email' },
    { id: 'phone', label: 'Phone' },
    { id: 'gender', label: 'Gender' },
    { id: 'Reciept', label: 'Reciept' },
];


const Screen = () => {
    const [students, setStudents] = useState([]);
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [studentsPerPage, setStudentsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [filterGender, setFilterGender] = useState('');
    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const [editedStudent, setEditedStudent] = useState({});
    const [pageSize, setPageSize] = useState(10);
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(true);
    const CLOUDINARY_URL = baseURL;
    const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;
    const [uploadedImageUrl, setUploadedImageUrl] = useState('');
    const [isReadOnly, setIsReadOnly] = useState(true);
    const [dataForprop, setDataForprop] = useState(null);
    const [showEmploymentFields, setShowEmploymentFields] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedFile(file);
    };

    useEffect(() => {
        fetchStudents();
    }, []);


    const [selectedProfileFile, setSelectedProfileFile] = useState(null);
    const [selectedNricFile, setSelectedNricFile] = useState(null);
    const [selectedPassportFile, setSelectedPassportFile] = useState(null);
    const [selectedEducationFile, setSelectedEducationFile] = useState(null);

    useEffect(() => {
        if (editedStudent) {
            setSelectedProfileFile(null);
            setSelectedNricFile(null);
            setSelectedPassportFile(null);
            setSelectedEducationFile(null);
        }
    }, [editedStudent]);

    const fetchStudents = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                "alumni"
            );
            console.log("students:", response);
            setStudents(response.data.reverse());
            setLoading(false);
        } catch (error) {
            console.error("Error fetching students:", error);
            setLoading(false);
        }
    };


    useEffect(() => {
        const filtered = students.filter((student) => {
            if (filterGender && filterGender.toLowerCase() !== "all") {
                return student.gender.toLowerCase() === filterGender.toLowerCase();
            }
            return true;
        });


        const searchFiltered = filtered.filter((student) =>
            student.name.toLowerCase().includes(searchQuery.toLowerCase())
        );


        setFilteredStudents(searchFiltered);
    }, [searchQuery, filterGender, students, currentPage, pageSize]);


    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1); // Reset to the first page when searching
    };

    const handleFilterGender = (gender) => {
        setFilterGender(gender);
        setCurrentPage(1); // Reset to the first page when applying filters
    };

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deletingStudentId, setDeletingStudentId] = useState(null);

    const DeleteConfirmationModal = ({ show, handleClose, handleConfirm }) => {
        return (
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this student?</Modal.Body>
                <Modal.Footer>
                    <Button style={{ backgroundColor: 'grey', color: 'white' }} onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button style={{ backgroundColor: 'red', color: 'white', marginLeft: '10px' }} onClick={() => handleConfirm(deletingStudentId)}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };


    const openDetailsModal = (student, isEdit) => {
        setEditedStudent(student);
        setIsReadOnly(!isEdit);
        setEditModalOpen(true);
    };

    const handleDelete = (id) => {
        setDeletingStudentId(id);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const handleConfirmDelete = async (id) => {
        try {
            // Send the PUT request to change the student's status
            await axios.put(`/registration/${id}/status`, { status: "Reject" });

            // Update the students state by filtering out the deleted student
            const updatedStudents = students.filter((student) => student.id !== id);
            setStudents(updatedStudents);
            setFilteredStudents(updatedStudents);

            // Show success message
            toast.success('Student deleted successfully');
        } catch (error) {
            console.error('Error deleting student:', error);
            // Handle error scenarios (e.g., showing an error message)
            toast.error('Failed to delete student. Please try again.');
        } finally {
            handleCloseDeleteModal();
        }
    };



    const openEditModal = (student) => {
        setEditedStudent(student);
        setEditModalOpen(true);
    };


    const closeEditModal = () => {
        setEditModalOpen(false);
    };



    const uploadFile = async (file, folderPath) => {
        const timestamp = Date.now();
        const fileExtension = file.name.split(".").pop();
        const fileNameWithTimestamp = `${timestamp}.${fileExtension}`;

        const formData = new FormData();
        formData.append("file", file, fileNameWithTimestamp);
        formData.append("upload_preset", CLOUDINARY_UPLOAD);
        formData.append("public_id", `${folderPath}/${fileNameWithTimestamp}`);

        const response = await fetch(CLOUDINARY_URL, {
            method: "POST",
            body: formData,
        });

        const data = await response.json();
        return data.secure_url || ""; // Return the uploaded file's URL
    };

    const handleSaveEdit = async (e) => {
        e.preventDefault();

        try {
            // Validate fields
            const requiredFields = ['name', 'email', 'phone', 'nric', 'password', 'officephone', 'address', 'passport', 'passportExpiryDate', 'citizenship', 'gender', 'profileUrl']; // Add all required field keys here
            const emptyFields = requiredFields.filter(
                (field) => !editedStudent[field] || editedStudent[field].trim() === ''
            );

            if (emptyFields.length > 0) {
                toast.error(`The following fields are required: ${emptyFields.join(', ')}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            }

            const confirmation = window.confirm(
                "Are you sure you want to update this student?"
            );
            if (!confirmation) {
                return;
            }

            // Existing URLs
            let profileUrl = editedStudent.profileUrl;
            let nricdoc = editedStudent.nricdoc;
            let passportdoc = editedStudent.passportdoc;
            let educationdoc = editedStudent.educationdoc;

            // Upload files if selected
            if (selectedProfileFile) {
                profileUrl = await uploadFile(
                    selectedProfileFile,
                    "LMS/Student/Profile"
                );
            }
            if (selectedNricFile) {
                nricdoc = await uploadFile(selectedNricFile, "LMS/Student/Nric");
            }
            if (selectedPassportFile) {
                passportdoc = await uploadFile(
                    selectedPassportFile,
                    "LMS/Student/Passport"
                );
            }
            if (selectedEducationFile) {
                educationdoc = await uploadFile(
                    selectedEducationFile,
                    "LMS/Student/Education"
                );
            }

            const updatedStudent = {
                ...editedStudent,
                profileUrl,
                nricdoc,
                passportdoc,
                educationdoc,
            };

            const response = await axios.put(
                `registrationadvances/${editedStudent.id}`,
                updatedStudent
            );

            if (response.status === 200) {
                const updatedStudents = students.map((student) =>
                    student.id === editedStudent.id ? updatedStudent : student
                );
                setStudents(updatedStudents);
                closeEditModal();
                toast.success("Student updated successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                console.error("Failed to update student");
                toast.error("Failed to update student", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (error) {
            console.error("Error updating student:", error);
            toast.error("An error occurred while updating the student", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };





    const handleBulkDownload = () => {
          console.log("students:", filteredStudents);
        const filteredData = filteredStudents.map(student => ({
            name: student.name,
            nric: student.nric,
            email: student.email,
            phone: student.phone,
            gender: student.gender,
            dob: student.dob,
            password: student.password,
            officephone: student.officephone,

            address: student.address,
            course: student.course,
            citizenship: student.citizenship,
            passport: student.passport,

            passportExpiryDate: student.passportExpiryDate,

            fatherName: student.fatherName,
            brotherName: student.brotherName,
            fatherPhoneNo: student.fatherPhoneNo,
            brotherPhoneNo: student.brotherPhoneNo,
            currentAddress: student.currentAddress,

            religion: student.religion,

            profileUrl: student.profileUrl,
            nricdoc: student.nricdoc,
            educationdoc: student.educationdoc,
            passportdoc: student.passportdoc,
            institutionDetails: student.institutionDetails.map(institution =>
                `${institution.institution} (${institution.year}, ${institution.qualificationsAchieved})`
            ).join('; '),
            workExpirences: student.workExpirences.map(experience =>
                `${experience.name} (${experience.year}, ${experience.position})`
            ).join('; ')
        }));

        // Create Excel workbook and sheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Students');

        // Generate Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Download Excel file
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Alumini_students.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };



    // const handleBulkDownload = async () => {
    //     console.log("students:", filteredStudents);

    //     const workbook = new ExcelJS.Workbook();
    //     const worksheet = workbook.addWorksheet('Students');

    //     // Define columns
    //     worksheet.columns = [
    //         { header: 'Name', key: 'name', width: 20 },
    //         { header: 'NRIC', key: 'nric', width: 15 },
    //         { header: 'Email', key: 'email', width: 25 },
    //         { header: 'Phone', key: 'phone', width: 15 },
    //         { header: 'Gender', key: 'gender', width: 10 },
    //         { header: 'DOB', key: 'dob', width: 15 },
    //         { header: 'Password', key: 'password', width: 15 },
    //         { header: 'Office Phone', key: 'officephone', width: 15 },
    //         { header: 'Address', key: 'address', width: 30 },
    //         { header: 'Course', key: 'course', width: 20 },
    //         { header: 'Citizenship', key: 'citizenship', width: 15 },
    //         { header: 'Passport', key: 'passport', width: 20 },
    //         { header: 'Passport Expiry Date', key: 'passportExpiryDate', width: 20 },
    //         { header: 'Father Name', key: 'fatherName', width: 20 },
    //         { header: 'Brother Name', key: 'brotherName', width: 20 },
    //         { header: 'Father Phone No', key: 'fatherPhoneNo', width: 18 },
    //         { header: 'Brother Phone No', key: 'brotherPhoneNo', width: 18 },
    //         { header: 'Current Address', key: 'currentAddress', width: 30 },
    //         { header: 'Religion', key: 'religion', width: 15 },
    //         { header: 'Profile URL', key: 'profileUrl', width: 30 },
    //         { header: 'NRIC Doc', key: 'nricdoc', width: 20 },
    //         { header: 'Education Doc', key: 'educationdoc', width: 20 },
    //         { header: 'Passport Doc', key: 'passportdoc', width: 20 },
    //         { header: 'Institution Details', key: 'institutionDetails', width: 40 },
    //         { header: 'Work Experiences', key: 'workExpirences', width: 40 }
    //     ];

    //     // Add data rows
    //     filteredStudents.forEach(student => {
    //         worksheet.addRow({
    //             name: student.name,
    //             nric: student.nric,
    //             email: student.email,
    //             phone: student.phone,
    //             gender: student.gender,
    //             dob: student.dob,
    //             password: student.password,
    //             officephone: student.officephone,
    //             address: student.address,
    //             course: student.course,
    //             citizenship: student.citizenship,
    //             passport: student.passport,
    //             passportExpiryDate: student.passportExpiryDate,
    //             fatherName: student.fatherName,
    //             brotherName: student.brotherName,
    //             fatherPhoneNo: student.fatherPhoneNo,
    //             brotherPhoneNo: student.brotherPhoneNo,
    //             currentAddress: student.currentAddress,
    //             religion: student.religion,
    //             profileUrl: student.profileUrl,
    //             nricdoc: student.nricdoc,
    //             educationdoc: student.educationdoc,
    //             passportdoc: student.passportdoc,
    //             institutionDetails: student.institutionDetails.map(i => `${i.institution} (${i.year}, ${i.qualificationsAchieved})`).join('; '),
    //             workExpirences: student.workExpirences.map(e => `${e.name} (${e.year}, ${e.position})`).join('; ')
    //         });
    //     });

    //     // Apply yellow background and borders to all cells
    //     worksheet.eachRow((row, rowNumber) => {
    //         row.eachCell(cell => {
    //             // Apply to all rows including headers
    //             cell.border = {
    //                 top: { style: 'thin' },
    //                 left: { style: 'thin' },
    //                 bottom: { style: 'thin' },
    //                 right: { style: 'thin' }
    //             };

    //             // Apply yellow fill only to data rows (rowNumber > 1)
    //             if (rowNumber > 1) {
    //                 cell.fill = {
    //                     type: 'pattern',
    //                     pattern: 'solid',
    //                     fgColor: { argb: 'FFFF99' } // Light yellow for data
    //                 };
    //             }
    //         });
    //     });

    //     // Generate file
    //     const buffer = await workbook.xlsx.writeBuffer();
    //     const blob = new Blob([buffer], {
    //         type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    //     });
    //     const url = URL.createObjectURL(blob);
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.setAttribute('download', 'Alumini_students_styled.xlsx');
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };


    const [isFocused, setIsFocused] = useState(false);



    const handleInstitutionChange = (index, e) => {
        const { name, value } = e.target;
        const newInstitutionDetails = editedStudent.institutionDetails.map((institution, i) => {
            if (i === index) {
                return { ...institution, [name]: value };
            }
            return institution;
        });
        setEditedStudent({ ...editedStudent, institutionDetails: newInstitutionDetails });
    };

    const handleAddEducation = () => {
        setEditedStudent({
            ...editedStudent,
            institutionDetails: [
                ...editedStudent.institutionDetails,
                { institution: '', year: '', qualificationsAchieved: '' },
            ],
        });
    };

    const handleRemoveEducation = (index) => {
        const newInstitutionDetails = editedStudent.institutionDetails.filter((_, i) => i !== index);
        setEditedStudent({ ...editedStudent, institutionDetails: newInstitutionDetails });
    };


    const handleWorkExperienceChange = (index, e) => {
        const { name, value } = e.target;
        const newWorkExperiences = editedStudent.workExpirences.map((experience, i) => {
            if (i === index) {
                return { ...experience, [name]: value };
            }
            return experience;
        });
        setEditedStudent({
            ...editedStudent,
            workExpirences: newWorkExperiences
        });
    };

    const handleAddWorkExperience = () => {
        setEditedStudent((prevState) => ({
            ...prevState,
            workExpirences: [
                ...prevState.workExpirences,
                { name: '', position: '', year: '' }
            ]
        }));
        setShowEmploymentFields(true); // Show employment fields after adding
    };

    const handleRemoveWorkExperience = (index) => {
        const newWorkExperiences = editedStudent.workExpirences.filter((_, i) => i !== index);
        setEditedStudent({
            ...editedStudent,
            workExpirences: newWorkExperiences
        });
        if (newWorkExperiences.length === 0) {
            setShowEmploymentFields(false); // Hide employment fields if no experience entries
        }
    };



    const handleViewStudent = async (student) => {
        // try {
        //     // First API call
        //     const response = await axios.get(`/student/${student.id}`);
        const courseFees = student.courseFees && student.courseFees.length > 0 ? student.courseFees : [];
        setPaymentDetails(courseFees);
        setShowModal(true);

        // } catch (error) {
        //     console.error('Error fetching student details:', error);
        // }
    };

    const handleCloseModal = () => {
        setShowModal(false);

    };


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1 and pad
        const year = date.getFullYear(); // Get full year

        return `${day}/${month}/${year}`;
    };

    const numberToWords = (number) => {
        const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        const suffixes = ['', 'Thousand'];


        const numToWords = (num) => {
            let words = '';
            if (num >= 1000) {
                words += numToWords(Math.floor(num / 1000)) + ' Thousand ';
                num %= 1000;
            }
            if (num >= 100) {
                words += ones[Math.floor(num / 100)] + ' Hundred ';
                num %= 100;
            }
            if (num >= 20) {
                words += tens[Math.floor(num / 10)] + ' ';
                num %= 10;
            }
            if (num > 0) {
                if (num >= 11 && num <= 19) {
                    words += teens[num - 10] + ' ';
                } else {
                    words += ones[num] + ' ';
                }
            }
            return words.trim();
        };

        if (number === 0) return 'Zero';
        return numToWords(number);
    };

    const handledownloadReciept = async (feeDetail) => {

        const pdfBytes = await fetch(courserecipt).then((res) => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(pdfBytes);

        const pages = pdfDoc.getPages();
        const firstPage = pages[0];

        // const courierfont = await pdfDoc.embedFont(StandardFonts.Courier);
        const courierfontbold = await pdfDoc.embedFont(StandardFonts.CourierBold);
        const courierfont = await pdfDoc.embedFont(StandardFonts.Courier);


        const amountText = feeDetail?.amount ? `$${feeDetail.amount}` : ''; // Ensure the dollar symbol is always present

        const balanceToDisplay = feeDetail?.feestype === 'Course fee'
            ? feeDetail?.courseFeebalance?.toString()
            : feeDetail?.registrationFeebalance?.toString();
        const sumOfDollars = numberToWords(feeDetail?.amount);
        // Convert numbers to strings
        firstPage.drawText(String(feeDetail?.studentName || '').toUpperCase(), { x: 162, y: 627, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
        firstPage.drawText(String(feeDetail?.finNric || ''), { x: 162, y: 602, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
        firstPage.drawText(String(removeBracketedText(feeDetail?.course) || '').toUpperCase(), { x: 162, y: 578, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
        // firstPage.drawText(String(feeDetail?.description || ''), { x: 35, y: 520, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
        firstPage.drawText(String(feeDetail?.invoiceNumber || ''), { x: 488, y: 676, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
        firstPage.drawText(String(formatDate(feeDetail?.date || '')), { x: 470, y: 664, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
        firstPage.drawText(amountText, { x: 497, y: 520, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
        firstPage.drawText(amountText, { x: 497, y: 460, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
        // firstPage.drawText(`${sumOfDollars} Dollars Only`, { x: 177, y: 464, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
        firstPage.drawText("AUD", { x: 498, y: 438, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
        firstPage.drawText(`Balance : $${balanceToDisplay}`, { x: 77, y: 485, size: 11, font: courierfont, color: rgb(0, 0, 0) });

        const drawWrappedText = async (page, text, x, y, font, fontSize, maxWidth) => {
            text = replaceTabs(text);
            const lines = [];
            let currentLine = '';
            const words = text.split(' ');

            for (let i = 0; i < words.length; i++) {
                const word = words[i];
                const width = getTextWidth(currentLine + ' ' + word, font, fontSize);

                if (width < maxWidth) {
                    currentLine += (currentLine === '' ? '' : ' ') + word;
                } else {
                    lines.push(currentLine.trim());
                    currentLine = word;
                }
            }

            if (currentLine !== '') {
                lines.push(currentLine.trim());
            }

            for (let i = 0; i < lines.length; i++) {
                const line = lines[i].trim();
                const lineWidth = getTextWidth(line, font, fontSize);

                await page.drawText(line, {
                    x: i === 0 ? x : x,
                    y: y - i * 12,
                    size: fontSize,
                    font,
                    color: rgb(0, 0, 0),
                });
            }
        };

        function replaceTabs(text) {
            return text.replace(/\t/g, '    '); // Replace each tab with four spaces
        }

        const getTextWidth = (text, font, fontSize) => {
            const width = font.widthOfTextAtSize(text, fontSize);
            return width;
        };

        let yPosition = 520;
        const lineHeight = 10;

        drawWrappedText(firstPage, String(feeDetail?.description || ''), 77, yPosition, courierfontbold, 10, 380);
        yPosition -= lineHeight;

        drawWrappedText(firstPage, `${sumOfDollars} Dollars Only`, 177, 464, courierfontbold, 10, 300);

        const pdfBytesModified = await pdfDoc.save();
        const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    };


    return (
        <div>
            <Header />
            <div className="container" style={{ maxWidth: '1400px' }}>

                <Typography
                    variant="h4"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                        color: "primary.main",
                        textDecoration: "underline",
                        textUnderlineOffset: "6px",
                        letterSpacing: "1px",
                        textAlign: "center",
                        mt: 3,
                        mb: 4,
                        fontSize: "2rem",
                    }}
                >
                    Alumini Student
                </Typography>



                {loading ? (
                    <Loader />
                ) : (

                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <br />
                        <Grid container spacing={3} alignItems="center">
                            {/* Search Input */}
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Search by Name"
                                    value={searchQuery}
                                    onChange={handleSearch}
                                    InputProps={{
                                        style: { borderRadius: "8px", height: "48px" }, // Ensures uniform height
                                    }}
                                />
                            </Grid>

                            {/* Gender Filter Dropdown */}
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel>Filter by Gender</InputLabel>
                                    <Select
                                        value={filterGender}
                                        onChange={(e) => setFilterGender(e.target.value)}
                                        label="Filter by Gender"
                                        sx={{ borderRadius: "8px", height: "48px", display: "flex", alignItems: "center" }}
                                    >
                                        <MenuItem value="All">All</MenuItem>
                                        <MenuItem value="Male">Male</MenuItem>
                                        <MenuItem value="Female">Female</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Bulk Download Button */}
                            <Grid item xs={12} md={4}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={handleBulkDownload}
                                    sx={{
                                        textTransform: "capitalize",
                                        borderRadius: "8px",
                                        fontWeight: "bold",
                                        height: "48px", // Ensures same height as inputs
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    Bulk Download
                                </Button>
                            </Grid>
                        </Grid>


                        <br />
                        <TableContainer
                            sx={{
                                overflowX: 'auto',
                                maxWidth: '100%',
                                '@media (min-width: 768px)': { // Apply styles for screens smaller than 768px (mobile)
                                    overflowX: 'unset', // Enable horizontal scroll
                                },
                            }}
                        >
                            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>

                                <Table aria-label="sticky table">
                                    <TableHead style={{ backgroundColor: 'black', position: 'sticky', top: 0, zIndex: 1 }}>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    align="left"
                                                    style={{ fontWeight: 'bold' }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredStudents.length > 0 ? (
                                            filteredStudents
                                                .slice((currentPage - 1) * studentsPerPage, currentPage * studentsPerPage)
                                                .map((student) => (
                                                    <TableRow key={student.id}>
                                                        <TableCell>
                                                            <span
                                                                title={`${student.name} details`}
                                                                style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
                                                                onClick={() => openDetailsModal(student, false)}
                                                            >
                                                                {student.name}
                                                            </span>
                                                        </TableCell>
                                                        {/* <TableCell>{student.nric}</TableCell> */}
                                                        <TableCell>
                                                            {student.nric
                                                                ? "*".repeat(student.nric.length - 4) + student.nric.slice(-4)
                                                                : "N/A"}
                                                        </TableCell>
                                                        <TableCell>{student.email}</TableCell>
                                                        <TableCell>{student.phone}</TableCell>
                                                        <TableCell>{student.gender}</TableCell>
                                                        <TableCell>
                                                            <Button variant="contained" onClick={() => handleViewStudent(student)}>
                                                                View
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={6} align="center" style={{ fontWeight: "bold", color: "gray", padding: "20px" }}>
                                                    No Data Available
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>

                                </Table>
                            </div>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={filteredStudents.length}
                            rowsPerPage={studentsPerPage}
                            page={currentPage - 1}
                            labelDisplayedRows={({ from, to }) => `${from}-${to} Page No ${currentPage}`}
                            onPageChange={(event, newPage) => setCurrentPage(newPage + 1)}
                            onRowsPerPageChange={(event) => {
                                setCurrentPage(1);
                                setStudentsPerPage(event.target.value);
                            }}
                        />
                    </Paper>
                )}
            </div>

            <Modal
                show={showModal}
                onHide={handleCloseModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                fullscreen
            >
                <Modal.Header closeButton>
                    {/* <Modal.Title>Student Details</Modal.Title> */}
                    {/* <Button onClick={handleDownloadPDF} variant="contained" color="primary">Download PDF</Button> */}
                </Modal.Header>
                <Modal.Body>
                    <div id="modalContent">
                        {paymentDetails && paymentDetails.length > 0 ? (
                            <>
                                <Grid item xs={10} md={6}>
                                    <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
                                        <Typography variant="h6" gutterBottom style={{ fontWeight: 'bolder' }}>Payment Details</Typography>
                                        <TableContainer>
                                            <Grid item xs={12} md={6}>
                                                <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
                                                    <div >
                                                        <div>
                                                            <Typography variant="h6" component="div" gutterBottom>
                                                                Course Fee Details
                                                            </Typography>
                                                            <TableContainer component={Paper}>
                                                                <Table aria-label="Registration fee details table">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell>Invoice Number</TableCell>
                                                                            <TableCell>Date</TableCell>
                                                                            <TableCell>Amount Paid</TableCell>
                                                                            <TableCell>Discount</TableCell>
                                                                            <TableCell>Description</TableCell>
                                                                            <TableCell>Action</TableCell>


                                                                            {/* <TableCell>Fee Type</TableCell> */}
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {paymentDetails
                                                                            .filter(feeDetail => feeDetail.feestype === "Course fee")
                                                                            .map((feeDetail, index) => (
                                                                                <TableRow key={index}>
                                                                                    <TableCell>{feeDetail.invoiceNumber}</TableCell>
                                                                                    <TableCell>{formatDate(feeDetail.date)}</TableCell>
                                                                                    <TableCell>${feeDetail.amount}</TableCell>
                                                                                    <TableCell>{feeDetail.discount ? `$${feeDetail.discount}` : "NA"}</TableCell>
                                                                                    <TableCell>{feeDetail.description}</TableCell>
                                                                                    <TableCell>
                                                                                        <Button
                                                                                            variant="contained"
                                                                                            color="primary"
                                                                                            // startIcon={<DownloadIcon />}
                                                                                            onClick={() => handledownloadReciept(feeDetail)} // Pass installment data here

                                                                                        >
                                                                                            View Receipt
                                                                                        </Button>
                                                                                    </TableCell>

                                                                                    {/* <TableCell>{feeDetail.feeType}</TableCell> */}
                                                                                </TableRow>
                                                                            ))}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>

                                                            <Typography variant="h6" component="div" gutterBottom style={{ marginTop: '20px' }}>
                                                                Registration Fee Details
                                                            </Typography>
                                                            <TableContainer component={Paper}>
                                                                <Table aria-label="Course Fee table">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell>Invoice Number</TableCell>
                                                                            <TableCell>Date</TableCell>
                                                                            <TableCell>Amount Paid</TableCell>
                                                                            <TableCell>Description</TableCell>
                                                                            {/* <TableCell>Action</TableCell> */}
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {paymentDetails
                                                                            .filter(feeDetail => feeDetail.feestype === "Registration fee")
                                                                            .map((feeDetail, index) => (
                                                                                <TableRow key={index}>
                                                                                    <TableCell>{feeDetail.invoiceNumber}</TableCell>
                                                                                    <TableCell>{formatDate(feeDetail.date)}</TableCell>
                                                                                    <TableCell>${feeDetail.amount}</TableCell>
                                                                                    <TableCell>{feeDetail.description}</TableCell>
                                                                                    {/* <TableCell>
                                                                                        <Button
                                                                                            variant="contained"
                                                                                            color="primary"
                                                                                            // startIcon={<DownloadIcon />}
                                                                                            onClick={() => handledownloadReciept(feeDetail)}  // Pass installment data here

                                                                                        >
                                                                                            View Receipt
                                                                                        </Button>

                                                                                    </TableCell> */}

                                                                                    {/* <TableCell>{installment.feeType}</TableCell> */}
                                                                                </TableRow>
                                                                            ))}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                        </div>
                                                    </div>

                                                </Paper>
                                            </Grid>

                                        </TableContainer>
                                    </Paper>
                                </Grid>

                            </>
                        ) : (
                            <Typography variant="h6" style={{ textAlign: 'center', margin: '20px' }}>
                                No payment details available for this student.
                            </Typography>
                        )}
                    </div>


                </Modal.Body>
            </Modal>


            <Dialog open={isEditModalOpen} onClose={closeEditModal}>
                <DialogTitle>
                    {isReadOnly ? 'Student Details' : 'Edit Student (AEG International College)'}
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSaveEdit}>
                        <div >
                            <TextField
                                label="Full Name"
                                name="fullname"
                                required
                                value={editedStudent ? editedStudent.name : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        const inputValue = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                        const truncatedValue = inputValue.substring(0, 25);
                                        if (truncatedValue.trim() !== '' || truncatedValue.length === 0) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                name: truncatedValue,
                                            });
                                        }
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />
                            <TextField
                                label="NRIC*"
                                name="nric"
                                value={editedStudent ? editedStudent.nric : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        // Validate input to allow only alphanumeric characters and limit to 12 characters
                                        const inputValue = e.target.value.replace(/[^A-Za-z0-9]/g, '').substring(0, 12);
                                        setEditedStudent({
                                            ...editedStudent,
                                            nric: inputValue,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />
                            <TextField
                                label="Email*"
                                name="email"
                                value={editedStudent ? editedStudent.email : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            email: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />


                            <TextField
                                label="Passport*"
                                name="passport"
                                value={editedStudent ? editedStudent.passport : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            passport: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                type="date"
                                label="Passport Expiry Date*"
                                name="passportexpiredate"
                                value={editedStudent ? editedStudent.passportExpiryDate : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            passportExpiryDate: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                label="Citizenship*"
                                name="citizenship"
                                value={editedStudent ? editedStudent.citizenship : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            citizenship: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                type="date"
                                label="offerDate*"
                                name="offerDate"
                                value={editedStudent ? editedStudent.offerDate : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            offerDate: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                label="Course*"
                                name="course"
                                value={editedStudent ? editedStudent.course : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            course: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: true }} // Set TextField as read-only based on isReadOnly
                            />


                            <div className="form-group">
                                <label>Gender*</label>
                                <Select
                                    className="form-control"
                                    name="gender"
                                    style={{
                                        width: '100%',
                                        height: '49px',
                                        borderRadius: '6px',
                                        border: `1px solid ${isFocused ? '#007bff' : '#ced4da'}`,
                                        fontSize: '14px',
                                        padding: '8px',
                                        backgroundColor: '#ffffff',
                                        color: '#495057',
                                        outline: 'none',
                                        boxShadow: isFocused ? '0 0 0 0.2rem rgba(0, 123, 255, 0.25)' : 'none',
                                    }}
                                    value={editedStudent ? editedStudent.gender : ''}
                                    onChange={(e) => {
                                        // Allow editing only if not in read-only mode
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                gender: e.target.value,
                                            });
                                        }
                                    }}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ readOnly: isReadOnly }} // Set Select as read-only based on isReadOnly
                                >
                                    <MenuItem value="">Select Gender</MenuItem>
                                    <MenuItem value="Male">Male</MenuItem>
                                    <MenuItem value="Female">Female</MenuItem>
                                    <MenuItem value="Other">Other</MenuItem>
                                </Select>
                            </div>


                            <div className="form-group">
                                <label>Date of Birth*</label>
                                <input
                                    type="date"

                                    label="Date of Birth"
                                    style={{ width: '100%', height: '49px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                    className={`form-control`}

                                    name="dob"
                                    value={editedStudent ? editedStudent.dob : '2000-01-01'} // Default value is set to '2000-01-01'
                                    onChange={(e) => {
                                        // Allow editing only if not in read-only mode
                                        if (!isReadOnly) {
                                            setEditedStudent({
                                                ...editedStudent,
                                                dob: e.target.value,
                                            });
                                        }
                                    }}
                                    // max="2012-12-31" // Set the maximum date
                                    // min="1920-01-01" // Set the minimum date
                                    readOnly={isReadOnly} // Set input as read-only based on isReadOnly
                                />
                            </div>

                            <TextField
                                label="Home Phone*"
                                name="phone"
                                value={editedStudent ? editedStudent.phone : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        // Validate input to allow only numeric characters and limit to 10 characters
                                        const inputValue = e.target.value.replace(/[^0-9]/g, '').substring(0, 8);
                                        setEditedStudent({
                                            ...editedStudent,
                                            phone: inputValue,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />


                            <TextField
                                label="Office Phone*"
                                name="officephone"
                                value={editedStudent ? editedStudent.officephone : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        // Validate input to allow only numeric characters and limit to 10 characters

                                        setEditedStudent({
                                            ...editedStudent,
                                            officephone: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />







                            <TextField
                                label="Password*"
                                name="password"
                                value={editedStudent ? editedStudent.password : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            password: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                label="Singapore Address"
                                name="currentAddress"
                                value={editedStudent ? editedStudent.currentAddress : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            currentAddress: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />



                            <TextField
                                label="Home Address*"
                                name="address"
                                value={editedStudent ? editedStudent.address : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            address: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            {/* <TextField
                                label="Race*"
                                name="race"
                                value={editedStudent ? editedStudent.race : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            race: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            /> */}

                            <TextField
                                label="Religion*"
                                name="religion"
                                value={editedStudent ? editedStudent.religion : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            religion: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />






                            <TextField
                                label="Father Name"
                                name="fatherName"
                                value={editedStudent ? editedStudent.fatherName : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            fatherName: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                label="Father Phone No"
                                name="fatherPhoneNo"
                                value={editedStudent ? editedStudent.fatherPhoneNo : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            fatherPhoneNo: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                label="Brother Name"
                                name="brotherName"
                                value={editedStudent ? editedStudent.brotherName : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            brotherName: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />

                            <TextField
                                label="Brother Phone No"
                                name="brotherPhoneNo"
                                value={editedStudent ? editedStudent.brotherPhoneNo : ''}
                                onChange={(e) => {
                                    // Allow editing only if not in read-only mode
                                    if (!isReadOnly) {
                                        setEditedStudent({
                                            ...editedStudent,
                                            brotherPhoneNo: e.target.value,
                                        });
                                    }
                                }}
                                fullWidth
                                margin="normal"
                                InputProps={{ readOnly: isReadOnly }} // Set TextField as read-only based on isReadOnly
                            />
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1">Upload photo</Typography>
                                    <TextField
                                        type="file"
                                        id="profileUpload"
                                        fullWidth
                                        inputProps={{ accept: 'image/*' }}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file && file.size > 8 * 1024 * 1024) {
                                                e.target.value = "";
                                                alert("File size must be less than 8MB.");
                                            } else {
                                                setSelectedProfileFile(file);
                                            }
                                        }} variant="outlined"
                                        style={{ marginTop: '8px' }}
                                    />
                                    {editedStudent?.profileUrl && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            href={editedStudent.profileUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ marginTop: '8px' }}
                                        >
                                            View
                                        </Button>
                                    )}
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1">Upload NRIC</Typography>
                                    <TextField
                                        type="file"
                                        id="nricUpload"
                                        fullWidth
                                        inputProps={{ accept: 'image/*' }}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file && file.size > 8 * 1024 * 1024) {
                                                e.target.value = "";
                                                alert("File size must be less than 8MB.");
                                            } else {
                                                setSelectedNricFile(file);
                                            }
                                        }} variant="outlined"
                                        style={{ marginTop: '8px' }}
                                    />
                                    {editedStudent?.nricdoc && (
                                        <Button
                                            variant="text"
                                            color="primary"
                                            href={editedStudent.nricdoc}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ marginTop: '8px' }}
                                        >
                                            View Current NRIC Document
                                        </Button>
                                    )}
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1">Upload Passport</Typography>
                                    <TextField
                                        type="file"
                                        id="passportUpload"
                                        fullWidth
                                        inputProps={{ accept: 'image/*' }}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file && file.size > 8 * 1024 * 1024) {
                                                e.target.value = "";
                                                alert("File size must be less than 8MB.");
                                            } else {
                                                setSelectedPassportFile(file);
                                            }
                                        }} variant="outlined"
                                        style={{ marginTop: '8px' }}
                                    />
                                    {editedStudent?.passportdoc && (
                                        <Button
                                            variant="text"
                                            color="primary"
                                            href={editedStudent.passportdoc}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ marginTop: '8px' }}
                                        >
                                            View Current Passport Document
                                        </Button>
                                    )}
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1">Upload Education Document</Typography>
                                    <TextField
                                        type="file"
                                        id="educationUpload"
                                        fullWidth
                                        inputProps={{ accept: 'application/pdf, image/*' }}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file && file.size > 8 * 1024 * 1024) {
                                                e.target.value = "";
                                                alert("File size must be less than 8MB.");
                                            } else {
                                                setSelectedEducationFile(file);
                                            }
                                        }}
                                        variant="outlined"
                                        style={{ marginTop: '8px' }}
                                    />
                                    {editedStudent?.educationdoc && (
                                        <Button
                                            variant="text"
                                            color="primary"
                                            href={editedStudent.educationdoc}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ marginTop: '8px' }}
                                        >
                                            View Current Education Document
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>Educational Details</Typography>
                            </Grid>

                            {editedStudent.workExpirences && (
                                editedStudent.institutionDetails.map((institution, index) => (
                                    <div key={index} >
                                        <div className="form-group">
                                            <label htmlFor={`institutionName-${index}`}>Institution Name-{index + 1}</label>
                                            <input
                                                type="text"
                                                id={`institutionName-${index}`}
                                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                className="form-control"
                                                name="institution"
                                                value={institution.institution}
                                                onChange={(e) => handleInstitutionChange(index, e)}

                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor={`degree-${index}`}>Degree</label>
                                            <input
                                                type="text"
                                                id={`degree-${index}`}
                                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                className="form-control"
                                                name="qualificationsAchieved"
                                                value={institution.qualificationsAchieved}
                                                onChange={(e) => handleInstitutionChange(index, e)}

                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor={`yearOfGraduation-${index}`}>Year of Graduation</label>
                                            <input
                                                type="text"
                                                id={`yearOfGraduation-${index}`}
                                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                className="form-control"
                                                name="year"
                                                value={institution.year}
                                                onChange={(e) => handleInstitutionChange(index, e)}

                                            />
                                        </div>
                                        {!isReadOnly && (
                                            <Button
                                                type="button"
                                                onClick={() => handleRemoveEducation(index)}
                                                style={{
                                                    margin: '10px 0',
                                                    padding: '5px 15px',
                                                    fontSize: '16px',
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    borderRadius: '8px',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    transition: 'background-color 0.3s ease',
                                                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                                }}
                                            >
                                                Remove
                                            </Button>

                                        )}
                                    </div>
                                ))
                            )}
                            {!isReadOnly && (
                                <Button
                                    type="button"
                                    onClick={handleAddEducation}
                                    disabled={isReadOnly}
                                    style={{
                                        margin: '10px 0',
                                        padding: '10px 20px',
                                        fontSize: '16px',
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        borderRadius: '8px',
                                        border: 'none',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease',
                                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    + Add Education
                                </Button>
                            )}


                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>Work Details</Typography>
                            </Grid>

                            {editedStudent.workExpirences && (
                                editedStudent.workExpirences.map((experience, index) => (
                                    <div key={index}>
                                        <div className="form-group">
                                            <label htmlFor={`companyname-${index}`}>Company Name-{index + 1}</label>
                                            <input
                                                type="text"
                                                id={`companyname-${index}`}
                                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                className="form-control"
                                                name="name"
                                                value={experience.name}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}

                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor={`position-${index}`}>Position</label>
                                            <input
                                                type="text"
                                                id={`position-${index}`}
                                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                className="form-control"
                                                name="position"
                                                value={experience.position}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}

                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor={`year-${index}`}>Year</label>
                                            <input
                                                type="text"
                                                id={`year-${index}`}
                                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                className="form-control"
                                                name="year"
                                                value={experience.year}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}

                                            />
                                        </div>

                                        {/* Button to remove the work experience entry */}
                                        {!isReadOnly && (
                                            <Button
                                                type="button"
                                                onClick={() => handleRemoveWorkExperience(index)}
                                                style={{
                                                    margin: '10px 0',
                                                    padding: '5px 15px',
                                                    fontSize: '16px',
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    borderRadius: '8px',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    transition: 'background-color 0.3s ease',
                                                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                                }}
                                            >
                                                Remove
                                            </Button>
                                        )}
                                    </div>
                                ))
                            )}
                            {!isReadOnly && (
                                <Button
                                    type="button"
                                    onClick={handleAddWorkExperience}
                                    style={{
                                        margin: '10px 0',
                                        padding: '10px 20px',
                                        fontSize: '16px',
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        borderRadius: '8px',
                                        border: 'none',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease',
                                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    + Add Employment

                                </Button>
                            )}



                        </div>    </form>
                </DialogContent>
                <DialogActions>
                    {!isReadOnly && ( // Conditionally render the Update button based on read-only mode
                        <Button onClick={handleSaveEdit} variant="contained" color="primary" style={{ backgroundColor: 'green', color: 'white' }}>
                            Update
                        </Button>
                    )}
                    <Button onClick={closeEditModal} variant="contained" color="secondary" style={{ backgroundColor: 'red', color: 'white' }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
            <DeleteConfirmationModal
                show={showDeleteModal}
                handleClose={handleCloseDeleteModal}
                handleConfirm={handleConfirmDelete}
            />
        </div >
    );
};


export default Screen;